(function documentRRHHFindControllerDefinition() {
    'use strict';

    angular.module('DocumentRRHH')
        .controller('DocumentRRHHFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processService', 'configViewService', 'authExtend', '$translate', 'storageService', 'alerts', 'organizationalUnitService', 'fileDownloader',
            function documentRRHHFindController($q, $filter, $scope, $state, errors, processService, configViewService, auth, $translate, storageService, alerts, organizationalUnitService, fileDownloader) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;

                    var filters = {
                        name: $scope.find.name,
                        processTypeId: $scope.find.processType.id,
                        organizationalUnitId: idOu,
                        processStatesIds: [],
                        metadatas: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    $scope.find.processType.metadatas.forEach(function (meta) {
                        filters.metadatas.push(meta);
                    });

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    } else {
                        $scope.find.processType.states.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    }

                    return filters;
                };

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();
                    $scope.loadActions();

                    return processService.advancedGet(filters).then(function (result) {
                        $scope.documents = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;
                            r.metadatas = [];

                            $scope.find.processType.headers.forEach(function (header) {
                                var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);
                                if (metadataFound && metadataFound.length != 0) {
                                    r.metadatas.push({ value: metadataFound[0].value, type: metadataFound[0].type, description: metadataFound[0].description });
                                } else {
                                    r.metadatas.push({ value: null, type: null, description: null });
                                }
                            });

                            $scope.documents.push(r);
                        });

                        if ($scope.documents.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.documents.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.findAction = function () {
                    if (!$scope.documentRRHHFind.$valid) {
                        $scope.documentRRHHFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setDocumentRRHHFilter($scope.find);

                    return $scope.executeFind();
                };

                $scope.loadPreFilters = function () {
                    if (!$scope.find.processType) {
                        var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                        $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                    }

                    $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.documents = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    $scope.loadPreFilters();
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;

                    storageService.clearDocumentRRHHFilter();

                    $scope.find = storageService.getDocumentRRHHFilter();
                    $scope.documents = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    $scope.loadPreFilters();

                    angular.forEach($scope.processTypes, function (item) {
                        if (item.id === $scope.find.processType.id) {
                            $scope.find.processType.metadatas = angular.copy(item.metadatas);
                        }
                    });
                };

                $scope.fillAccordion = function () {
                    $scope.documents.forEach(function (doc) {
                        var accordionIsOpen = false;
                        Object.defineProperty(doc, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.exportToExcel = function () {
                    return $translate(['DocumentOrganizationalUnits', 'ProcessReceptionDateView', 'DocumentFileName', 'ProcessState'])
                        .then(function (translated) {
                            var headers = [];
                            var filters = $scope.createFilters();
                            filters.itemPerPage = null;
                            filters.page = null;

                            headers.push({ key: "OrganizationalUnitName", value: translated.DocumentOrganizationalUnits });
                            headers.push({ key: "CreationDate", value: translated.ProcessReceptionDateView });
                            headers.push({ key: "Name", value: translated.DocumentFileName });

                            $scope.find.processType.headers.forEach(function (header) {
                                headers.push({ key: header.systemName, value: header.label });
                            });

                            headers.push({ key: "StateAlias", value: translated.ProcessState });

                            return processService.exportToXLS(filters, headers, 'Documentos').then(function (result) {
                                var d = new Date();

                                var docName = "Documentos";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                errors.showError('Api failed');
                            });
                        });
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.resultCriteria) {
                            processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                        }

                        if (metadata.searchCriteria) {
                            processType.metadatas.push({
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType != null ? metadata.metadataType.toLowerCase() : undefined,
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.searchCriteria.name,
                                metadataReadOnly: !metadata.searchCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.searchCriteria.order
                            });
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.states.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($scope.processTypes && $scope.processTypes.length > 0) {
                        defered.resolve();
                    } else {
                        $q.all([configViewService.getById("CPPDocumentRRHH"), organizationalUnitService.getRootOf(auth.getOrganizationId())]).then(function (result) {
                            var configView = result[0];
                            var rootOu = result[1].filter(function (item) { return item.isRoot })[0];
                            if (configView.processTypes && configView.processTypes.length > 0) {
                                $scope.processTypes = [];

                                angular.forEach(configView.processTypes, function (item) {
                                    if (item.organizationalUnitId == rootOu.id) {
                                        $scope.loadMetadata(item);
                                    }
                                });

                                if ($scope.processTypes.length === 0) {
                                    defered.reject('DocumentNoCustomProcessType');
                                }
                            }

                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    }

                    return promise;
                };

                $scope.loadActions = function () {
                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        var bDelete = $scope.find.selectedStates.every(function (item) {
                            return item.delete;
                        });

                        var bEdit = $scope.find.selectedStates.every(function (item) {
                            return item.edit;
                        });

                        $scope.actions = {
                            delete: bDelete,
                            edit: bEdit,
                            editName: $scope.find.selectedStates[0].editName,
                            editNameAll: $scope.find.selectedStates[0].editName + 'All'
                        };
                    }
                };

                $scope.load = function () {
                    $scope.loading = false;
                    $scope.checkAll = false;

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    $scope.signPermission = auth.isInRole('DOCUMENT MULTIPLE SIGN');
                    $scope.deletePermission = auth.isInRole('DOCUMENT MULTIPLE DELETE');
                    $scope.sendDocumentPermission = auth.isInRole('DOCUMENT WRITE');
                    $scope.find = storageService.getDocumentRRHHFilter();

                    $q.all([$scope.loadViewOptions()]).then(function (result) {
                        $scope.loadPreFilters();
                        $scope.executeFind();
                    }, function (error) {
                        errors.showError(error);
                        $state.go('inicio');
                    });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.documents.length > 0) {
                        $scope.documents.forEach(function (pc) {
                            pc.check = $scope.checkAll;
                        });
                    }
                };

                $scope.sign = function () {
                    var toSign = [];

                    $scope.documents.forEach(function (doc) {
                        if (doc.check) {
                            toSign.push(doc);
                        }
                    });

                    if (toSign.length == 0) {
                        errors.showError('SignNoProcess');
                    } else {
                        processService.setSignProcesses(toSign);
                        $state.go('document-rrhh-sign');
                    }
                };

                $scope.signAll = function () {
                    var toSign = [];

                    var filters = $scope.createFilters();
                    filters.itemPerPage = 0;
                    filters.page = 1;

                    return processService.advancedGet(filters).then(function (result) {
                        toSign = result.values;
                        if (toSign.length == 0) {
                            errors.showError('SignNoProcess');
                        } else {
                            processService.setSignProcesses(toSign);
                            $state.go('document-rrhh-sign');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.delete = function () {
                    var toDelete = [];

                    $scope.documents.forEach(function (doc) {
                        if (doc.check) {
                            toDelete.push(doc.id);
                        }
                    });

                    if (toDelete.length == 0) {
                        return errors.showError('DeleteNoProcess');
                    } else {
                        return $translate(['Warning', 'DocumentDeleteMultipleConfirmText', 'Yes', 'No']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DocumentDeleteMultipleConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    $scope.loading = true;

                                    processService.deleteBatch(toDelete).then(function (resultCount) {
                                        var success = {
                                            data: {
                                                key: 'DeleteMultipleSucces',
                                                value: { processesCount: resultCount, from: toDelete.length }
                                            }
                                        }
                                        errors.showSuccess(success);
                                        $scope.loading = false;
                                        $scope.load();
                                    }, function (error) {
                                        $scope.loading = false;
                                        errors.showError(error);
                                    });;
                                } else {
                                    $scope.loading = false;
                                }
                            });
                        });
                    }
                };

                $scope.deleteAll = function () {
                    var toDelete = [];
                    var filters = $scope.createFilters();

                    filters.itemPerPage = 0;
                    filters.page = 1;

                    return processService.advancedGet(filters).then(function (result) {
                        result.values.forEach(function (doc) {
                            toDelete.push(doc.id);
                        });

                        if (toDelete.length == 0) {
                            return errors.showError('DeleteNoProcess');
                        } else {
                            return $translate(['Warning', 'DocumentDeleteMultipleConfirmText', 'Yes', 'No']).then(function (translated) {
                                return alerts.confirm(translated.Warning, translated.DocumentDeleteMultipleConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                                    if (result) {
                                        $scope.loading = true;

                                        processService.deleteBatch(toDelete).then(function (resultCount) {
                                            var success = {
                                                data: {
                                                    key: 'DeleteMultipleSucces',
                                                    value: { processesCount: resultCount, from: toDelete.length }
                                                }
                                            }
                                            errors.showSuccess(success);
                                            $scope.loading = false;
                                            $scope.load();
                                        }, function (error) {
                                            $scope.loading = false;
                                            errors.showError(error);
                                        });;
                                    } else {
                                        $scope.loading = false;
                                    }
                                });
                            });
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.view = function (doc) {
                    $state.go('document-rrhh-detail', { id: doc.id });
                };

                $scope.add = function () {
                    $state.go('document-rrhh-add', { employeeFiles: [] });
                };

                $scope.load();

            }]);
})();